import React, { useState, useMemo } from "react";
import "./TenantSelectorModal.css";

export default function TenantSelectorModal({ tenants, onSelect }) {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return tenants;
    return tenants.filter(
      (t) => (t.name || "").toLowerCase().includes(q) || t.code.toLowerCase().includes(q)
    );
  }, [tenants, search]);

  return (
    <div className="tenant-selector-overlay">
      <div className="tenant-selector-modal">
        <div className="tenant-selector-header">
          <img src="/videri-logo.png" alt="Videri" className="tenant-selector-logo" />
          <h2>Select a tenant</h2>
        </div>

        <div className="tenant-selector-body">
          <input
            className="tenant-selector-search"
            type="text"
            placeholder="Search tenants…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          <div className="tenant-selector-list">
            {filtered.length === 0 && (
              <div className="tenant-selector-empty">No tenants match "{search}"</div>
            )}
            {filtered.map((t) => (
              <button
                key={t.code}
                className={`tenant-selector-item${selected?.code === t.code ? " selected" : ""}`}
                onClick={() => setSelected(t)}
              >
                <span className="tenant-selector-name">{t.name || t.code}</span>
                <span className="tenant-selector-code">{t.code}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="tenant-selector-footer">
          <button
            className="tenant-selector-continue"
            disabled={!selected}
            onClick={() => selected && onSelect(selected)}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
